
<a href="" class="btn">
  <i v-if="checked" class="fa fa-lg fa-check-square checked"></i>
  <i v-else class="fa fa-lg fa-check-square "></i>
  {{ title }}
</a>
